import * as React from 'react';

import {colors} from '../../colors/colors';

type Props = {
    value: string | number;
    fieldName?: string;
    isLeadCard?: boolean;
};

export function Date(props: Props) {
    if (props.isLeadCard && props.fieldName === 'overdueDuration') {
        return <div style={{color: colors.overdue}}>{props.value}</div>;
    }

    return props.value;
}
